

import React from 'react';
import { Link } from 'react-router-dom';

export const MobileActionButtons: React.FC = () => {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 z-40 md:hidden">
      <div className="flex space-x-3">
        <a
          href="mailto:sales@engvar.ru"
          className="flex-1 bg-red-600 hover:bg-red-700 text-white font-semibold py-3 px-2 rounded-lg transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center text-sm"
        >
          <div className="w-5 h-5 flex items-center justify-center mr-2">
            <i className="ri-mail-line"></i>
          </div>
          Написать
        </a>
        <a
          href="tel:+78124081913"
          className="flex-1 bg-gray-800 hover:bg-gray-900 text-white font-semibold py-3 px-2 rounded-lg transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center text-sm roistat-phone"
        >
          <div className="w-5 h-5 flex items-center justify-center mr-2">
            <i className="ri-phone-line"></i>
          </div>
          Позвонить
        </a>
      </div>
    </div>
  );
};
